var map = {
	"./active-bg.png": "HrZJ",
	"./ag-active.png": "B+3D",
	"./ag-default.png": "W4Oo",
	"./bb-active.png": "g+Ss",
	"./bb-default.png": "fRTk",
	"./logo_ag.png": "Ev/A",
	"./logo_bb.png": "4pdl",
	"./logo_ob.png": "CS9f",
	"./logo_og.png": "kiwO",
	"./ob-active.png": "fdTj",
	"./ob-default.png": "mAwT",
	"./og-active.png": "TTrq",
	"./og-default.png": "rBk4",
	"./peopleGame1.png": "fRq/",
	"./peopleGame2.png": "qInv",
	"./peopleGame3.png": "k2T9",
	"./peopleGame4.png": "huDI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0vbc";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/video ^\.\/.*\.png$
// module id = 0vbc
// module chunks = 3